import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_comp_label_hdr_RowClass } from '../../../dbschema/bl_fi_comp_label_hdr.model';

export class CompanyLabelHdrContainerModel extends BaseContainerModel {
  bl_fi_comp_label_hdr: bl_fi_comp_label_hdr_RowClass = new bl_fi_comp_label_hdr_RowClass();
}